import { useBackgroundQuery } from '@apollo/client';

import { PRODUCT_BASIC_DETAILS } from '../queries';
import useProductBasicQueryOptions from './useProductBasicQueryOptions';

const useBackgroundProductBasicDetails = (
  id,
  slug,
  queryOptions = {},
  hookOptions = {
    skip: false,
  }
) => {
  const options = useProductBasicQueryOptions({
    id,
    slug,
    queryOptions,
    hookOptions,
  });

  const [queryRef] = useBackgroundQuery(PRODUCT_BASIC_DETAILS, options);

  return queryRef;
};

export default useBackgroundProductBasicDetails;
